import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(web)/terms/page.tsx");
